<template>
  <div class="container mx-auto p-8">
  	<h1 class="page-header">My Account</h1>
  	<div class="mt-5 flex justify-center">
	    <ul class="mt-10 mr-10 flex whitespace-nowrap lg:flex-col" role="list">
		    <li>
		        <button
		            @click="currentSection = 'general'"
		            class="group py-2 pl-2 pr-3 group flex items-center gap-x-3 leading-6 hover:text-green-700 font-medium rounded-md"
		            :class="currentSection == 'general' ? 'text-green-600' : 'text-gray-700'">
		                <inline-svg name="user" classes="w-5 h-5" />
		                General
		        </button>
		    </li>
		    <li>
		        <button
		            @click="currentSection = 'notifications'"
		            class="group py-2 pl-2 pr-3 group flex items-center gap-x-3 leading-6 hover:text-green-700 font-medium rounded-md"
		            :class="currentSection == 'notifications' ? 'text-green-600' : 'text-gray-700' ">
		                <inline-svg name="bell" classes="w-5 h-5" />
		                Notifications
		        </button>
		    </li>
	    </ul>
	    <div class="mx-auto w-[42rem] lg:mx-0 bg-gray-50">
				<div class="p-10">

					<div v-if="currentSection == 'general'">
		        <h2 class="page-header pb-3 border-b border-gray-200">General</h2>

		        <div class="mx-3 space-y-10 sm:space-y-14">
		        	<div class="mt-2">
				        <dl class="space-y-2 divide-y divide-gray-100 text-sm leading-6">
				          <div class="pt-3 sm:flex items-center">
				            <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Full name</dt>
				            <dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
				              <div class="text-gray-900">
				              	<input v-model="user.name" type="text" class="form-input" placeholder="Your Name" />
				              	<p v-if="errors.name" class="form-error">{{ errors.name[0] }}</p>
				              </div>
				            </dd>
				          </div>
				          <div class="pt-3 sm:flex items-center">
				            <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Email address</dt>
				            <dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
				              <div class="text-gray-900">
				              	<input v-model="user.email" type="text" class="form-input" placeholder="Your Email" required />
				              	<p v-if="errors.email" class="form-error">{{ errors.email[0] }}</p>
				              </div>
				            </dd>
				          </div>
				          <div class="pt-3 sm:flex items-center">
				            <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Department</dt>
				            <dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
				              <div class="text-gray-900">
				              	<input v-model="user.department" type="text" class="form-input" placeholder="e.g. Management" />
				              </div>
				            </dd>
				          </div>
				          <div class="pt-3 sm:flex items-center">
				            <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Title</dt>
				            <dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
				              <div class="text-gray-900">
				              	<input v-model="user.title" type="text" class="form-input" placeholder="e.g. CFO" />
				              </div>
				            </dd>
				          </div>
				          <div class="pt-3 sm:flex items-center">
				            <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Cell #</dt>
				            <dd class="mt-1 flex justify-between gap-x-1 sm:mt-0 sm:flex-auto">
				              <div class="text-gray-900">
				              	<input v-model="user.cell" type="text" class="form-input" placeholder="Your cellphone #" />
				              	<p v-if="errors.cell" class="form-error">{{ errors.cell[0] }}</p>
				              </div>
				              <div class="text-gray-900">
												<select v-model="user.cell_carrier_id" class="mt-0 form-select">
													<option value=""></option>
													<option
														v-for="carrier in cellCarrierData" :key="carrier.id"
														:value="carrier.id">
															{{ carrier.carrier }}
													</option>
												</select>
				              	<p v-if="errors.cell_carrier_id" class="form-error">{{ errors.cell_carrier_id[0] }}</p>
				              </div>
				            </dd>
				          </div>
				        </dl>
		        	</div>

							<div>
				        <h3 class="text-base font-semibold leading-7 text-gray-900">Locale</h3>

				        <dl class="mt-3 space-y-2 divide-y divide-gray-100 border-t border-gray-200 text-sm leading-6">
				          <div class="pt-3 sm:flex items-center">
				            <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Country</dt>
				            <dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
				              <div class="text-gray-900">
												<select v-model="user.country_id" class="mt-0 form-select">
													<option
														v-for="country in countries" :key="country.id"
														:value="country.id">
															{{ country.name }}
													</option>
												</select>
				              </div>
				            </dd>
				          </div>
				        </dl>
							</div>

							<div>
				        <h3 class="text-base font-semibold leading-7 text-gray-900">Reset Password</h3>

				        <dl class="mt-3 space-y-2 divide-y divide-gray-100 border-t border-gray-200 text-sm leading-6">
				          <div class="pt-3 sm:flex items-center">
				            <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Password</dt>
				            <dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
				              <div class="text-gray-900">
												<input v-model="password" type="password" class="form-input" />
												<p v-if="errors.password" class="form-error">{{ errors.password[0] }}</p>
				              </div>
				            </dd>
				          </div>

				          <div class="pt-3 sm:flex items-center">
				            <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Confirm New Password</dt>
				            <dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
				              <div class="text-gray-900">
												<input v-model="password_confirmation" type="password" class="form-input" />
				              </div>
				            </dd>
				          </div>
				        </dl>
							</div>
						</div>
					</div>

					<div v-if="currentSection == 'notifications'">
						<h2 class="page-header pb-3 border-b border-gray-200">Notifications</h2>

						<div class="ml-2 mt-8">
							<h3 class="pb-1 text-lg border-b border-gray-200">Key Date Notifications</h3>
							<div class="my-5 alert blue text-sm">
								Notifications are sent out 1 year, 6 months and 1 month before the Key Date is due
							</div>
							<div class="mt-4 flex flex-col space-y-4">
								<div class="flex items-center gap-x-2 text-sm">
									<toggle-switch-small v-model="user.wants_keydate_emails" name="email-notifications"></toggle-switch-small>
									Email me about upcoming Key Dates
								</div>

								<div class="flex items-center gap-x-2 text-sm">
									<toggle-switch-small v-model="user.wants_task_notifications" name="task-notifications"></toggle-switch-small>
									Email me about task updates
								</div>

								<div class="flex flex-col">
									<div class="flex items-center gap-x-2 text-sm">
										<toggle-switch-small v-model="user.wants_keydate_texts" name="text-notifications"></toggle-switch-small>
										<div class="flex flex-col">
											Text me about upcoming Key Dates
											<div v-if="user.wants_keydate_texts" class="mt-1 flex gap-x-1">
					              <div class="text-gray-900">
					              	<input v-model="user.cell" type="text" class="form-input" placeholder="Your cellphone #" />
					              	<p v-if="errors.cell" class="form-error">{{ errors.cell[0] }}</p>
					              </div>
					              <div class="text-gray-900">
													<select v-model="user.cell_carrier_id" class="mt-0 form-select">
														<option value=""></option>
														<option
															v-for="carrier in cellCarrierData" :key="carrier.id"
															:value="carrier.id">
																{{ carrier.carrier }}
														</option>
													</select>
					              	<p v-if="errors.cell_carrier_id" class="form-error">{{ errors.cell_carrier_id[0] }}</p>
					              </div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<button @click="saveUser" type="button" class="mt-10 btn btn-green self-end">Save</button>
				</div>
	  	</div>
		
			<notifications classes="notification" position="bottom right"></notifications>
	  </div>
	</div>
</template>

<script>
  export default {
    props: {
    	countryData: {
    		type: [Array, Object],
    		required: true
    	},

    	cellCarrierData: {
    		type: [Array, Object],
    		required: true
    	},

    	userData: {
    		type: [Array, Object],
    		required: true
    	}
    },

    data() {
			return {
				currentSection: 'general',
				user: this.userData,
				countries: this.countryData,
				password: null,
				password_confirmation: null,
				errors: {}
			}
    },

    methods: {
    	saveUser() {
    		this.errors = {};

    		delete this.user.password;
    		delete this.user.password_confirmation;

    		if (! [null, ''].includes(this.password) && ! [null, ''].includes(this.password_confirmation)) {
    			this.user.password = this.password;
    			this.user.password_confirmation = this.password_confirmation;
    		}

    		axios.patch('/my-account/' + this.user.id, this.user).then((response) => {
    			localStorage.setItem(`reopt_baseCurrency`, response.data.user.country.currency.code);
    			localStorage.setItem(`reopt_locale`, response.data.user.country.locale);

    			this.password = null;
    			this.password_confirmation = null;

          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Account Updated'
          });
    		}).catch(error => {
    			this.errors = error.response.data.errors;
    		})
    	}
    },
  }
</script>